var EN = EN || {};

EN.ArchiveSticky = (function ($) {

	var options = {
		selectors: {
			archive: '.en-archive',
			seasonStickyTitle: '.en-calendar__season-title',
			mainFilter: '.en-filter__main',
			header: '.en-header',
			sentinel: '.en-sticky-helper__sentinel',
			calendarDateBig: '.en-calendar__date-big',
			calendarDateSmall: '.en-calendar__date-small',
			filter: '.en-filter',
		},
		rawSelectors: {
			isStickyContainer: 'en-is-sticky-container',
			isSticky: 'en-is-sticky',
		}
	}

	/**
	 * Holding the instance on EN.IntersectionSticky
	 */
	var archiveSeasonTitlesIntersectionSticky = undefined;

	var getSeasonTitleHeight = function () {
		var $seasonTitle = document.querySelector(options.selectors.seasonStickyTitle);

		if ($seasonTitle) {
			return $seasonTitle.offsetHeight;
		}

		return 104;
	}

	var getCaledarSeasonStickyTitleTopPosition = function () {
		var headerHeight = document.querySelector(options.selectors.header).offsetHeight;
		var filtersHeight = 0;
		document.querySelectorAll(options.selectors.mainFilter).forEach(function ($filter) {
			filtersHeight += $filter.offsetHeight;
		});

		return headerHeight + filtersHeight;
	}

	var getCalendarDayDateStickyTopPosition = function () {
		return (getCaledarSeasonStickyTitleTopPosition() + getSeasonTitleHeight());
	}

	var getIntersectionRootMargin = function () {
		return (-1 * getCaledarSeasonStickyTitleTopPosition()) + 'px 0px 0px 0px';
	}

	var updateCaledarSeasonStickyTitleTopPosition = function () {
		document.body.style.setProperty('--en-season-sticky-title-top', getCaledarSeasonStickyTitleTopPosition() + 'px');
	}

	var updateCalendarDayDateStickyTopPosition = function () {
		document.body.style.setProperty('--en-season-big-date-sticky-top', getCalendarDayDateStickyTopPosition() + 'px');
	}

	var createIntersectionSticky = function () {
		updateCaledarSeasonStickyTitleTopPosition();
		updateCalendarDayDateStickyTopPosition();

		// Array.from(document.querySelectorAll(options.selectors.seasonStickyTitle)).forEach(function ($seasonStickyTitle) {
		// $seasonStickyTitle.style.top = getCaledarSeasonStickyTitleTopPosition() + 'px'; 
		// }); // switch to CSS variable

		archiveSeasonTitlesIntersectionSticky = new EN.IntersectionSticky({
			sticky: options.selectors.seasonStickyTitle,
			intersectionRootMargin: getIntersectionRootMargin(),
			scrollContainer: null, // viewport
			topSentinelHeight: '1px',
			bottomSentinelHeight: '110px',
			debugMode: false,
		});

	}

	var reCreateIntersectionSticky = function () {
		if (archiveSeasonTitlesIntersectionSticky) {
			archiveSeasonTitlesIntersectionSticky.disconnect();
			Array.from(document.querySelectorAll(options.selectors.sentinel)).forEach(function ($sentinel) {
				$sentinel.remove();
			});
		}

		createIntersectionSticky();
	}

	var init = function () {

		// bail early
		if (document.querySelectorAll(options.selectors.archive).length === 0) {
			return;
		}

		createIntersectionSticky();

		window.addEventListener('resize', function () {
			reCreateIntersectionSticky();
		});

		document.addEventListener('en/sticky/change', function (e) {
			if (e.detail.isSticky) {
				//add classes
				e.detail.target.classList.add(options.rawSelectors.isSticky);
				e.detail.target.parentElement.classList.add(options.rawSelectors.isStickyContainer);

				// define sticky title height - only for active sticky
				seasonStickyTitleHeight = e.detail.target.offsetHeight;

				// set sticky day date top
				// Array.from(e.detail.target.parentElement.querySelectorAll(options.selectors.calendarDateBig)).forEach(function ($dateElement) {
				// 	$dateElement.style.top = getCalendarDayDateStickyTopPosition();
				// });
			} else {
				// remove classes
				e.detail.target.classList.remove(options.rawSelectors.isSticky);
				e.detail.target.parentElement.classList.remove(options.rawSelectors.isStickyContainer);
			}
		});

		// Events from Lemon 42
		document.addEventListener('extended-search-opened', function () {
			updateCaledarSeasonStickyTitleTopPosition();
			updateCalendarDayDateStickyTopPosition();
		});

		document.addEventListener('extended-search-closed', function () {
			updateCaledarSeasonStickyTitleTopPosition();
			updateCalendarDayDateStickyTopPosition();
		});

		// Mutation Observer for filters
		var filterMutationObserver = new MutationObserver(function () {
			updateCaledarSeasonStickyTitleTopPosition();
			updateCalendarDayDateStickyTopPosition();
		});

		var $filterContainer = document.querySelector(options.selectors.filter);
		if ($filterContainer) {
			filterMutationObserver.observe($filterContainer, {
				childList: true,
				attributes: true,
				subtree: true,
			});
		}

		// dirty hack I know
		setInterval(function () {
			updateCaledarSeasonStickyTitleTopPosition();
			updateCalendarDayDateStickyTopPosition();
		}, 500)

	}

	return {
		init: init
	}

}(jQuery));